module.exports = __webpack_public_path__ + "img/aidt-aw-logo-new.76adba88.jpg";